import Vue from 'vue'
import {
  ShButton,
  ShImage
} from '@sohohouse/design-system'

Vue.component('ShButton', ShButton)
Vue.component('ShImage', ShImage)
